export const blockIconsCommunicationEmail = (
	<span className='material-symbols-outlined'>email</span>
);
